import { AdDetails } from '@amzn/safeframe-model';

/**
 * return metadata string to log in order to identify creatives/templates that may have issues
 */
export const getCreativeMetadata = (adDetails: AdDetails): string => {
    const metadata =
        `ProgramId: ${adDetails.adCreativeMetaData.adProgramId}, CreativeId: ${adDetails.adCreativeMetaData.adCreativeId}, ` +
        `AdId: ${adDetails.adCreativeMetaData.adId}, Template: ${adDetails.adCreativeMetaData.adCreativeTemplateName}`;
    const size = getRelativeSize(adDetails.htmlContentEncodedLength);
    return `${metadata} (html size: ${size})`;
};

/**
 * get size in relative size to avoid having high cardinality for creatives
 */
const getRelativeSize = (contentSize: number | undefined): string => {
    if (contentSize === undefined) {
        return 'N/A';
    }
    if (contentSize === 0) {
        return '0';
    }
    if (contentSize <= 5000) {
        return '0<x<=5k';
    }
    if (contentSize <= 100000) {
        return '5k<x<=100k';
    }
    return '>100k';
};
